<template>
  <v-col cols="12" xl="6">
    <v-lazy
        v-model="lazyActive"
        min-height="300"
        :options="{
        threshold: 0.1,
      }"
        transition="fade-transition"
    >
      <v-card flat elevation="5" height="100%">
        <div class="d-flex justify-center">
          <span class="chart-title">標籤趨勢圖</span>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" size="18"
              >mdi-help-circle-outline
              </v-icon
              >
            </template>
            <pre>{{ reportData.helpIcon.annotation }}</pre>
          </v-tooltip>
        </div>

        <v-tabs v-model="tab" grow>
          <v-tabs-slider></v-tabs-slider>

          <v-tab
              v-for="item in tabItem"
              :key="item.id"
              @click="scrollTo(`#populationTag`)"
          >
            {{ item.name }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20"
                >mdi-help-circle-outline
                </v-icon
                >
              </template>
              <span>{{ item.helpIconMsg }}</span>
            </v-tooltip>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in tabItem" :key="item.id">
            <v-card flat min-height="400">
              <Charts :option="populationTags"/>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-lazy>
  </v-col>
</template>
<script>
import {mapGetters} from "vuex";
import {exportCSV} from "@/plugins/exportCsv";

export default {
  components: {
    Charts: () => import("@/components/Charts.vue"),
  },
  methods: {
    scrollTo(target) {
      this.$emit("goto", target);
    },
    downloadCSV() {
      const report = this.tab
          ? this.getWeekPoupulationsTagReport //vuex
          : this.getPopulationTags;
      var [tagCount, growthRate] = report.series;

      tagCount = tagCount.data.map((item) => item.y);
      growthRate = growthRate.data.map((item) => item.labels);

      const dates = this.tab
          ? [...this.getWeekDateRange]
          : [...this.getDateRange];

      const fileName = this.tab
          ? `${this.getPopulationTags.subtitle}-${this.reportData.title.text}` + "(週平均趨勢)"
          : `${this.getPopulationTags.subtitle}-${this.reportData.title.text}`;

      const header = this.tab
          ? [`日期`, `週平均貼標數`, `與母體週平均成長率差`]
          : [`日期`, `貼標數`, `與母體日成長率差`];

      exportCSV(fileName, header, dates, tagCount, growthRate);
    },
    getOption(tab) {
      const option = JSON.parse(JSON.stringify(this.reportData));
      const report = tab
          ? this.getWeekPoupulationsTagReport //vuex
          : this.getPopulationTags;

      option.xAxis.categories = this.getDateRange;

      option.subtitle.text = report.subtitle;
      option.series = report.series;
      return option;
    },
  },
  computed: {
    ...mapGetters("taganalysis", [
      "getDateRange",
      "getPopulationTags",
      "getWeekDateRange",
      "getWeekPoupulationsTagReport",
    ]),
    populationTags() {
      const option = this.reportData;
      // console.log("option",option)
      const report = this.tab
          ? this.getWeekPoupulationsTagReport //vuex
          : this.getPopulationTags;

      option.xAxis.categories = this.getDateRange;

      option.subtitle.text = report.subtitle;
      option.series = report.series;
      option.exporting.buttons.contextButton.menuItems = [
        {
          textKey: "downloadCSV",
          onclick: () => {
            this.downloadCSV();
          },
        },
      ];
      return option;
    },
  },
  data: () => ({
    lazyActive: false,

    tab: null,
    tabItem: [
      {
        id: 1,
        name: "每日趨勢",
        helpIconMsg:
            "以每日為單位，顯示選定標籤的每日貼標數及與母體標籤日成長率之差",
      },
      {
        id: 2,
        name: "週平均趨勢",
        helpIconMsg:
            "以週平均為單位，顯示選定標籤的週平均貼標數及與母體標籤週平均成長率之差",
      },
    ],

    reportData: {
      chart: {
        zoomType: "x",
        // resetZoomButton: {
        //   relativeTo: "chart",
        // },
        height: "450",
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        type: "date",
        // tickInterval: 1,

        labels: {
          formatter() {
            return this.value.length > 5 ? this.value.substring(5) : null; //有日期=>value.length>5,沒日期=>value=index
          },
        },
        categories: [],
      },
      yAxis: [
        {
          // tickInterval: 200,
          title: {
            text: "貼標數",
          },

          plotLines: [
            {
              value: 0,
              width: 1,
              color: "#808080",
            },
          ],
          opposite: false,
        },
        {
          // tickInterval: 200,

          title: {
            text: "成長率差",
          },

          plotLines: [
            {
              value: 0,
              width: 1,
            },
          ],
          opposite: true,
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        borderWidth: 0,
      },
      plotOptions: {
        series: {
          cursor: "pointer",
          point: {},
          animation: {
            duration: 600,
          },
        },
      },
      series: [],
      tooltip: {
        formatter() {
          const {category, y, dateRange} = this.point;
          switch (this.series.name) {
            case "週平均貼標數":
              return `
          ${dateRange}<br>
          週平均貼標數 : <b>${y}</b>
          `;

            case "週平均成長率差":
              return `
             ${dateRange}<br>
          與母體週平均成長率差 : <b>${y}</b>`;

            case "日貼標數":
              return `
            ${category}<br>
          貼標數 : <b>${y}</b>`;

            case "日成長率差":
              return `
            ${category}<br>
          與母體日成長率差 : <b>${y}</b>`;
          }
        },
      },
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
      },
      helpIcon: {
        annotation:
            `透過貼標數(長條圖)可以了解標籤貼標數趨勢變化，而成長率差(折線圖)可以知道相對母體標籤的成長率的差，是否有更顯著的成長。
成長率差大於0，表示此標籤在網站成長率高於母體成長率 ; 反之，網站成長率低於母體成長率。`,
        enabled: false,
      },
    },
  }),
  props: {
    chartInfoState: Boolean,
  },
  watch: {
    chartInfoState() {
      if (this.chartInfoState === true) {

        const WeekPoupulationsTagReport = {
          data: this.getOption(false),
          id: "populationTagDay"
        };
        this.$emit("addChartInfo", WeekPoupulationsTagReport);
        const PopulationTags = {
          data: this.getOption(true),
          id: "populationTagWeek"
        };
        this.$emit("addChartInfo", PopulationTags);
      }
    }
  },
};
</script>

<style lang="css" scoped>
.chart-title {
  font-size: 18px;
  margin-top: 5px;
}
</style>
